/* Source strings are already Russian, so the RU dictionary is an identity (empty) — translate() returns the key as-is */
const data = {}

export default data
